export const AUTH_TOKEN = '@5487a8f8e4a6634d9a5ae38ce4c65e87'
export const COOKIE_AUTH_TOKEN = '@1e1eaa960912de05ee019913a7f3991a'
export const REGISTRATION_COMPANY_TOKEN = '@dbbfda36dfe998a5d3f2ba4dbd10bdee'
export const REGISTRATION_COOKIE_TOKEN = '@21d18d66007562288afbe68aa59df73c'
export const COMPANY_BANNER_TOKEN = '@3d5fa0d3f31399bfa2ae242feac678ef'
